import { roles } from './../routes';
import { AuthorizeStep } from 'authorizeStep';
import { Router } from 'aurelia-router';
import { autoinject } from 'aurelia-framework';

@autoinject
export class StartComponent {
  constructor(private router: Router) {
    if (AuthorizeStep.auth.roles) {
      this.navigateToStartComponent();
    } else {
      setTimeout(() => {
        this.retryDefaultNavigation();
      }, 100);
    }
  }

  private retryDefaultNavigation() {
    if (AuthorizeStep.auth.roles) {
      this.navigateToStartComponent();
    } else {
      setTimeout(() => {
        this.retryDefaultNavigation();
      }, 100);
    }
  }

  private navigateToStartComponent() {
    if (AuthorizeStep.auth.roles.find((x) => x == roles.sales || x == roles.administrator)) {
      this.router.navigate('dashboard');
    } else if (AuthorizeStep.auth.roles.find((x) => x == roles.production)) {
      this.router.navigate('orders');
    } else if (AuthorizeStep.auth.roles.find((x) => x == roles.analysisEngineer)) {
      this.router.navigate('analysis/list');
    } else if (AuthorizeStep.auth.roles.find((x) => x == roles.leader)) {
      // this.router.navigate('management');
    } else if (AuthorizeStep.auth.roles.find((x) => x == roles.serviceuser || x == roles.superService)) {
      this.router.navigate('services');
    } else if (AuthorizeStep.auth.roles.find((x) => x == roles.serviceInvoicing)) {
      this.router.navigate('invoicing-list-service');
    } else if (AuthorizeStep.auth.roles.find((x) => x == roles.mooringSeller || x == roles.mooringAdministrator)) {
      this.router.navigate('mooring/offers');
    } else if (AuthorizeStep.auth.roles.find((x) => x == roles.mooringcalculation)) {
      this.router.navigate('mooring/calculation-report');
    } else if (AuthorizeStep.auth.roles.find((x) => x == roles.pensSales || x == roles.pensAdministrator)) {
      this.router.navigate('pens/offers');
    } else if (AuthorizeStep.auth.roles.find((x) => x == roles.pensProduction || x == roles.pensProductionSupervisor)) {
      this.router.navigate('pens/orders');
    }
  }
}
